var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDentacasaai(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93372 0.273629C1.24881 3.01237 1.46296 21.9815 7.93357 24.7203C14.17 26.599 26 18.6231 26 12.4831C26 6.34314 12.9957 -1.577 7.93372 0.273629ZM15.8522 11.2903C16.5112 12.8878 15.7557 14.7191 14.1647 15.3808C12.5737 16.0424 10.7497 15.2839 10.0907 13.6865C9.43166 12.0891 10.1872 10.2577 11.7782 9.59605C13.3692 8.93438 15.1932 9.69294 15.8522 11.2903Z",
    fill: "#582DC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1585 13.6207C10.8063 15.2128 12.607 16.0043 14.1707 15.3448C16.6984 14.2788 19.5746 15.4637 20.6216 18.0372C21.6686 20.6108 20.4683 23.5612 17.9406 24.6272C12.5738 26.8905 0 18.35 0 12.444C0 6.53807 12.1749 -1.56186 17.9404 0.261589C20.4681 1.32759 21.6685 4.27803 20.6215 6.85157C19.5744 9.42512 16.6984 10.7212 14.1707 9.65517C13.4124 9.33537 12.5685 9.32286 11.7805 9.65517C10.2439 10.3448 9.56098 11.9828 10.1585 13.6207Z",
    fill: "#9573E8",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentacasaai);
export default __webpack_public_path__ + "static/media/dentacasaai.c886ce7f9facc291bf6b000de9c4ab0a.svg";
export { ForwardRef as ReactComponent };